import { render } from "./FileStoragePainter.vue?vue&type=template&id=10ec3743"
import script from "./FileStoragePainter.vue?vue&type=script&lang=js"
export * from "./FileStoragePainter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__